var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Button from '../Button/Button';
import Checkbox from '../Checkbox/Checkbox';
import React, { useCallback, useEffect, useState } from 'react';
import { Rnd } from 'react-rnd';
import { calcChronometry, countWords } from './Chronometer';
import styles from './Chronometer.module.css';
import { TooltipSimple } from '../TooltipSimple/TooltipSimple';
export default function ChronometerPopup(_a) {
    var onClose = _a.onClose, _b = _a.isDesktop, isDesktop = _b === void 0 ? true : _b;
    var vWidth = window.innerWidth;
    var vMiddle = vWidth / 2;
    var rndStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: isDesktop ? 440 : vWidth,
        zIndex: 1001
    };
    var _c = __read(useState({
        wordsCount: 0,
        chron: 0,
        chronTextValue: sessionStorage.getItem('chronText') || '',
        autocopy: sessionStorage.getItem('chronAutocopy') === 'true' || false
    }), 2), chronState = _c[0], setChronState = _c[1];
    var handleChange = useCallback(function (text) {
        setChronState(function (prev) {
            return __assign(__assign({}, prev), { wordsCount: countWords(text), chron: calcChronometry(text), chronTextValue: text });
        });
        sessionStorage.setItem('chronText', text);
    }, []);
    useEffect(function () {
        setChronState(function (prev) {
            return __assign(__assign({}, prev), { wordsCount: countWords(chronState.chronTextValue), chron: calcChronometry(chronState.chronTextValue) });
        });
    }, [chronState.chronTextValue]);
    var doc = document;
    useEffect(function () {
        var unmounted = false;
        if (chronState.autocopy) {
            doc.addEventListener('click', function (e) {
                if ((e.target['tagName'] === 'INPUT' && e.target.type === 'text') ||
                    e.target['tagName'] === 'TEXTAREA') {
                    if (!unmounted) {
                        handleChange(e.target.value);
                    }
                }
                else if (e.target.className ===
                    'se-wrapper-inner se-wrapper-wysiwyg sun-editor-editable') {
                    if (!unmounted) {
                        handleChange(e.target.textContent);
                    }
                }
            });
        }
        return function () {
            unmounted = true;
            doc.removeEventListener('click', function () { });
        };
    });
    return (React.createElement(Rnd, { style: rndStyle, default: {
            x: isDesktop
                ? vMiddle < rndStyle.width
                    ? vMiddle - (rndStyle.width - vMiddle)
                    : vWidth > 1200
                        ? vMiddle + 100
                        : vMiddle
                : 0,
            y: 63,
            width: rndStyle.width,
            height: 0
        }, minWidth: 390, minHeight: 290, bounds: 'window', dragHandleClassName: 'handle' },
        React.createElement("div", { className: styles.chronPopup },
            React.createElement("div", { className: 'handle', style: {
                    width: '100%',
                    height: 40,
                    cursor: 'move',
                    position: 'absolute'
                } }),
            React.createElement("div", { className: styles.label },
                React.createElement("span", null, "\u041E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u0445\u0440\u043E\u043D\u043E\u043C\u0435\u0442\u0440\u0430\u0436\u0430 \u0442\u0435\u043A\u0441\u0442\u0430"),
                React.createElement("button", { className: isDesktop ? styles.cross : styles.crossMobile, onClick: function () {
                        onClose();
                    } })),
            React.createElement("textarea", { placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442 \u0438\u043B\u0438 \u043A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u043D\u0430 \u043B\u044E\u0431\u043E\u043C \u043F\u043E\u043B\u0435 \u0441 \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u043C', className: styles.textArea, onChange: function (e) {
                    handleChange(e.target.value);
                }, value: chronState.chronTextValue }),
            React.createElement("div", { className: styles.infoContainer },
                React.createElement(Button, { onClick: function () {
                        handleChange('');
                    }, title: 'Очистить', style: {
                        height: 28,
                        padding: 0,
                        marginLeft: 20,
                        marginBottom: 10,
                        marginTop: 10
                    } }),
                React.createElement(Checkbox, { label: 'Авто', checked: chronState.autocopy, setChecked: function (toggle) {
                        setChronState(function (prev) {
                            return __assign(__assign({}, prev), { autocopy: toggle });
                        });
                        sessionStorage.setItem('chronAutocopy', toggle.toString());
                    }, style: { display: 'inline-block', marginLeft: 10, marginTop: 15 } }),
                React.createElement(TooltipSimple, { text: 'Когда функция активна, содержимое копируется & автоматически по клику на текстовом поле', closeOnOutsideClick: true, style: { marginTop: 7, marginLeft: 7 } })),
            React.createElement("div", { className: styles.infoRow },
                "\u0421\u043B\u043E\u0432: ",
                chronState.wordsCount),
            React.createElement("div", { className: styles.infoRow },
                React.createElement("span", { className: styles.infoRowBold }, "\u041E\u043F\u0442\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0445\u0440\u043E\u043D\u043E\u043C\u0435\u0442\u0440\u0430\u0436: "),
                chronState.chron,
                " \u0441\u0435\u043A"))));
}
